import { render, staticRenderFns } from "./MyPropertiesScreen.vue?vue&type=template&id=37a55e56&scoped=true"
import script from "./MyPropertiesScreen.vue?vue&type=script&lang=js"
export * from "./MyPropertiesScreen.vue?vue&type=script&lang=js"
import style0 from "./MyPropertiesScreen.vue?vue&type=style&index=0&id=37a55e56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a55e56",
  null
  
)

export default component.exports